// extracted by mini-css-extract-plugin
export default {"container":"errorPage_container__sumo8","title":"errorPage_title__E-Pjk","message":"errorPage_message__nJ9ll","link":"errorPage_link__AWVGI"};